import MyAiChatThreadsAPI from 'dashboard/api/my_ai/myAiChatThreads';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'MyAiChatThreads',
  API: MyAiChatThreadsAPI,
});
